import { render, staticRenderFns } from "./VerNotas.vue?vue&type=template&id=57a1640d&scoped=true"
import script from "./VerNotas.vue?vue&type=script&lang=js"
export * from "./VerNotas.vue?vue&type=script&lang=js"
import style0 from "./VerNotas.vue?vue&type=style&index=0&id=57a1640d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a1640d",
  null
  
)

export default component.exports